import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { ApolloProvider } from '@apollo/client'
import apolloClient from './lib/apollo-client'
import { Provider } from 'react-redux'
import store from './store'

// Wrap the App component with both Redux Provider and ApolloProvider
// This ensures proper state management and GraphQL error handling
createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <ApolloProvider client={apolloClient}>
      <App />
    </ApolloProvider>
  </Provider>
);
